module.exports = __webpack_public_path__ + "static/media/delivery_guru_tips.fcc45cf9.png";